var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/-sound-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.99999998,0.999999955 C8.55227999,0.999999955 8.99999998,1.34314996 8.99999998,2.99999995 L8.99999998,17 C8.99999998,18.6569 8.55227999,19 7.99999998,19 C7.44771999,19 6.99999998,18.6569 6.99999998,17 L6.99999998,2.99999995 C6.99999998,1.34314996 7.44771999,0.999999955 7.99999998,0.999999955 Z M3.99999996,2.99999996 C4.55227997,2.99999996 4.99999996,3.34314997 4.99999996,4.99999996 L4.99999996,15 C4.99999996,16.6569 4.55227997,17 3.99999996,17 C3.44771997,17 2.99999996,16.6569 2.99999996,15 L2.99999996,4.99999996 C2.99999996,3.34314997 3.44771997,2.99999996 3.99999996,2.99999996 Z M16,4.99999997 C16.5523,4.99999997 17,5.34314998 17,6.99999997 L17,6.99999997 L17,13 C17,14.6569 16.5523,15 16,15 C15.4477,15 15,14.6569 15,13 L15,13 L15,6.99999997 C15,5.34314998 15.4477,4.99999997 16,4.99999997 Z M12,6.99999998 C12.5523,6.99999998 13,7.34314999 13,8.99999998 L13,11 C13,12.6569 12.5523,13 12,13 C11.4477,13 11,12.6569 11,11 L11,8.99999998 C11,7.34314999 11.4477,6.99999998 12,6.99999998 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}));

function SvgSoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.6c5b3692.svg";
export { ForwardRef as ReactComponent };